import { gold, textMuted } from '@/theme/colors'
import { fontBody } from '@/theme/fonts'
import styled from 'styled-components'

/** Centered zero-state body: icon over a friendly line. Fills the tile body. */
export const EmptyBody = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	gap: 10px;
	padding: 20px 8px;
	color: ${textMuted};
`

export const EmptyIcon = styled.span`
	color: ${gold};
	display: inline-flex;
`

export const EmptyText = styled.p`
	font-family: ${fontBody};
	font-size: 14px;
	color: ${textMuted};
	margin: 0;
	max-width: 260px;
	line-height: 1.5;
`
